import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './index.css';
import { router } from './Routes/Routes';
import React from 'react';

// Auto-recuperação após deploy: uma aba antiga pode pedir um chunk JS que não existe
// mais na versão nova (ChunkLoadError). Em vez de tela branca/erro exigindo Ctrl+R,
// recarrega a página uma vez para pegar a versão nova (janela de 15s evita loop).
function isChunkError(message?: string): boolean {
  if (!message) return false;
  return /ChunkLoadError|Loading chunk [\d]+ failed|Loading CSS chunk|error loading dynamically imported module|Failed to fetch dynamically imported module/i.test(message);
}
function recoverFromChunkError(message?: string) {
  if (!isChunkError(message)) return;
  const last = Number(sessionStorage.getItem('chunkReloadAt') || '0');
  if (Date.now() - last > 15000) {
    sessionStorage.setItem('chunkReloadAt', String(Date.now()));
    window.location.reload();
  }
}
window.addEventListener('error', (e) => recoverFromChunkError(e?.message || (e?.error && e.error.message)));
window.addEventListener('unhandledrejection', (e) => {
  const reason: any = e?.reason;
  recoverFromChunkError(typeof reason === 'string' ? reason : reason?.message);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(

  <RouterProvider router={router} />
);
